import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="19.75",
  height="15.637", 
  viewBox="0 0 19.75 15.637"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path fill={fill} id="menu" d="M106.615 145.938v6.025c0 .917-.708 1.729-1.993 2.288a10.548 10.548 0 0 1-4.084.743.282.282 0 0 1-.281-.283V147.9l-.009-.009v-.043-.03a.282.282 0 0 1 .281-.285 9.291 9.291 0 0 0 3.535-.628c.707-.307 1.163-.708 1.163-1.023s-.457-.716-1.163-1.023a9.29 9.29 0 0 0-3.535-.628 10.677 10.677 0 0 0-2.435.271.124.124 0 0 1-.09-.013 7.118 7.118 0 0 0-.674-.335 8.8 8.8 0 0 0-.876-.324.125.125 0 0 1-.013-.235 11.6 11.6 0 0 1 8.169 0c1.285.558 1.993 1.371 1.993 2.288v.052zm-4.269-.052c0-.436-.813-.789-1.817-.789a3.2 3.2 0 0 0-1.364.268c-.282.139-.453.321-.453.521 0 .358.55.661 1.3.757a4.062 4.062 0 0 0 .514.032c1.007.001 1.821-.353 1.821-.789zm-3.328 1.714h.009v7.865c0 .917-.708 1.729-1.993 2.288a11.6 11.6 0 0 1-8.169 0c-1.285-.558-1.993-1.371-1.993-2.288v-7.748q-.008-.084-.008-.169c0-.917.708-1.729 1.993-2.288a11.6 11.6 0 0 1 8.169 0c1.285.558 1.993 1.371 1.993 2.288.001.015 0 .033-.001.052zm-1.378-.052c0-.314-.457-.716-1.163-1.023a10.255 10.255 0 0 0-7.069 0c-.707.307-1.163.708-1.163 1.023v.017h.007v.056c.063.3.5.666 1.155.95a10.255 10.255 0 0 0 7.069 0c.708-.309 1.164-.711 1.164-1.025zm-4.7-.789c-1 0-1.817.353-1.817.789s.813.789 1.817.789 1.817-.353 1.817-.789-.811-.791-1.815-.791z" className="cls-1" transform="translate(-86.865 -142.856)"/>
  </svg>
);

export default SVG;



// WEBPACK FOOTER //
// ./src/components/UI/Icons/Menu.js